import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { IDataFlow, IDataFlowMappingTypeProperties, IDataFlowProperties } from 'app/model/adapters/dataflow/IDataflow';
import { DataFlowAdapter } from './dataflow.adapter';
import { UserDefinedFunctionLibrary } from 'app/model/dataflow/user-defined-function-library';
import { UserDefinedFunction } from 'app/model/dataflow/user-defined-function';
import { DataFlowExpressionUtils } from './expression.util';
import { UserDefinedFunctionsService } from 'app/services/user-defined-functions.service';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(UserDefinedFunctionLibrary),
    asynchronous: true
})
export class UserDefinedFunctionLibraryAdapter extends DataFlowAdapter {

    public getUDFDSL(functions: UserDefinedFunction[]): string[] {
        const script = functions.length > 0 ? `${functions.map((func) => {
            const funcArgumentTypes = func.functionArgs.map((arg) => arg.type as string);
            return `${func.name}(${funcArgumentTypes.join(', ')}) as ${func.returnType} = ${DataFlowExpressionUtils.wrapExpressionWithEmptyValue(func.funcExpression.expression)}`;
        }).join(',\n')}` : '';
        return script.replace(/\t/g, '     ').split(/\n/g);
    }

    public async postToModel(value: UserDefinedFunctionLibrary): Promise<void> {
        (await getServiceInstance<UserDefinedFunctionsService>(this.context.contextData, 'UserDefinedFunctionsService')).addLibrary(value);
    }

    protected async _toModel(resource: IDataFlow, model?: UserDefinedFunctionLibrary): Promise<UserDefinedFunctionLibrary> {
        if (!model) {
            model = UserDefinedFunctionLibrary.MODEL.create<UserDefinedFunctionLibrary>();
        }

        model = await super.parseJSONToModel(resource, model) as UserDefinedFunctionLibrary;
        await model.parseUdfDslAsync(this.context, resource);
        return model;
    }

    protected async _toResource(library: UserDefinedFunctionLibrary): Promise<IDataFlow> {
        const resource = await super._toResource(library) as IDataFlow;

        if (resource && resource.properties) {
            resource.name = library.name;
            (resource.properties as IDataFlowProperties).type = 'UDFLibrary';
            ((resource.properties as IDataFlowProperties).typeProperties as IDataFlowMappingTypeProperties).scriptLines = this.getUDFDSL(library.libraryFunctions);
        }

        return resource;
    }
}
